/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */
import PRM from "@/core/PermissionConstants";

export default {
  path: "/app/psicologia/consultas-pendientes",
  name: "PSYCHOLOGY_ATTEND",
  component: () => import("@/app/views/crud/CrudView.vue"),
  meta: {
    service: () => import("@/app/services/PsychologyService"),
    table: () => import("@/app/components/psychology/consultation/PsychologyTable"),
    form: () => import("@/app/components/psychology/consultation/PsychologyForm"),

    header: {
      icono: "mdi-brain",
      texto: "Consultas pendientes | Psicología",
      textNew: "Atender Consulta | Psicología",
      textEdit: "Editar Consulta | Psicología",
      textView: "Visualizar consulta | Psicología"
    },
    prm: PRM.MODULE_PSYCHOLOGY_CONSULTATION,
    requireAuth: true,
    filterDate: true,
    hideButtonAdd: true,
    filterModality: true,
    cancelationModal: true,
    generatePDFModal: true,
    saveButton: "Finalizar Consulta",
    labelDate: "Seleccione fecha",
    namePDF: "Psicología",
    module: "psicologia"
  },
};
